import { MonthCalendar, todayIso } from "@/components/site/Calendar";

export const BlockedDates = ({ value, onChange }) => {
  const toggle = (d) => onChange(value.includes(d) ? value.filter((x) => x !== d) : [...value, d].sort());
  const upcoming = value.filter((d) => d >= todayIso());
  return (
    <div className="fe-field" data-testid="admin-blocked-dates">
      <label>Zajęte terminy – kliknij dzień, żeby go zablokować lub odblokować</label>
      <MonthCalendar blocked={value} onDay={toggle} adminMode months={3} />
      <p className="adm-sub" style={{ margin: 0 }} data-testid="blocked-count">
        Zablokowane nadchodzące dni: {upcoming.length ? upcoming.map((d) => new Date(d + "T12:00").toLocaleDateString("pl-PL", { day: "numeric", month: "short" })).join(", ") : "brak"}
      </p>
    </div>
  );
};
